<template>
  <div :class="[currIsPc ? '' : 'mobile-contact-us', 'contact-us']">
    <h4>お問い合せ</h4>
    <div class="contact-content">
      <p>お問い合わせがございます場合はメールにてご連絡ください。</p>
      <p>お問い合わせには可能な限り早く返信いたしますが、</p>
      <p>内容や状況によってはお時間をいただきます。</p>
      <br />
      <p>また、お問い合わせ内容により、</p>
      <p>回答を控えさせていただく場合もございます。</p>
      <p>あらかじめご了承ください。</p>
      <p>※お電話でのサポートは行っておりません。</p>
      <br />
      <p>こちらのメールアドレスからお問い合わせをお願いします。</p>
      <a class="email" href="mailto:akakuro@moonton.com">akakuro@moonton.com</a>
      <br />
      <p>不具合など調査が必要な案件のご報告は、</p>
      <p>なるべく公式サイトからのお問い合わせをお願いいたします。</p>
      <br />
      <p>@moonton.comのドメインより返信するため、</p>
      <p>@moonton.comからのメールの受信ができるよう設定をお願い致します。</p>
    </div>
  </div>
</template>

<script>
import { isPc } from "@/util/index";
export default {
  computed: {
    currIsPc() {
      return isPc();
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-us {
  font-size: 18px;
  color: #dde0f7;
  line-height: 26px;
  h4 {
    color: #ffe6aa;
    font-size: 38px;
    text-align: center;
    margin-top: 42px;
    margin-bottom: 28px;
  }
  .contact-content {
    padding-left: 175px;

    .email {
      display: block;
      color: #ffe6aa;
      text-decoration: none;
    }
  }

  &.mobile-contact-us {
    @include ft(18);
    @include lh(26);
    h4 {
      @include ft(38);
      text-align: center;
      @include mt(90);
      @include mb(50);
    }
    .contact-content {
      padding-left: 175px;
      @include plr(40);
    }
  }
}
</style>
